import statuses from '@/store/statuses';
import Services from '@/services/index';
import VT from '@/store/types';

export default {
  [VT.LANGUAGES_LIST]: ({ commit, state }, page = 1) => {
    state.languagesList['status'] = statuses.LOADING;
    Services.languages.list(page).then((data) => {
      commit(VT.LANGUAGES_LIST, data);
    }).catch((errResponse) => {
      commit(VT.LANGUAGES_LIST, errResponse);
    });
  },
  [VT.LANGUAGES_CLASSIFICATOR]: ({ commit, state }) => {
    state.languagesClassifier['status'] = statuses.LOADING;
    Services.languages.classifier().then((data) => {
      commit(VT.LANGUAGES_CLASSIFICATOR, data);
    }).catch((data) => {
      commit(VT.LANGUAGES_CLASSIFICATOR, data);
    });
  },
  [VT.LANGUAGE_CREATE_DATA]: () => {
    return new Promise((resolve, reject) => {
      Services.languages.createData().then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.LANGUAGE_UPDATE_DATA]: ({}, id) => {
    return new Promise((resolve, reject) => {
      Services.languages.editData(id).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.LANGUAGE_CREATE]: ({}, createData) => {
    return new Promise((resolve, reject) => {
      Services.languages.create(createData).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.LANGUAGE_UPDATE]: ({}, updateData) => {
    return new Promise((resolve, reject) => {
      Services.languages.update(updateData).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.LANGUAGE_DELETE]: ({}, id) => {
    return new Promise((resolve, reject) => {
      Services.languages.delete(id).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
};
